import { render, staticRenderFns } from "./SensorSetup.vue?vue&type=template&id=e9a304e6&scoped=true&"
import script from "./SensorSetup.vue?vue&type=script&lang=js&"
export * from "./SensorSetup.vue?vue&type=script&lang=js&"
import style0 from "./SensorSetup.vue?vue&type=style&index=0&id=e9a304e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9a304e6",
  null
  
)

export default component.exports